<template>
  <PInput
    v-model.number="otp"
    hide-bottom-space
    label-classes="text-neutral-100 text-weight-medium"
    label="Verification Code"
    required
    :disable="!isBankSelected"
    :validations="{
      label: 'Verification Code',
      required: true,
      length: 6,
      type: 'number',
    }"
    placeholder="Enter 6-digit verification code"
  >
    <template #append>
      <span
        v-if="isTimerShown"
        class="text-neutral-100 text-weight-regular text-xs bg-primary-30"
      >
        {{ timer }}
      </span>
      <PBtn
        dense
        flat
        outline
        text
        :loading="isLoading"
        class="q-my-xxs"
        :label="computedBtnLabel"
        size="md"
        :disable="isSendOTPBtnDisabled"
        @click="sendOTP"
      />
    </template>
  </PInput>
  <span v-if="phone" class="text-neutral-90 text-xs text-weight-neutral-90"
    >Enter 6-digit verification code sent to +91{{ phone }}
  </span>
</template>

<script setup>
import useOtp from "../composables/otp";

const otp = defineModel({ type: [String, Number] });

const props = defineProps({
  isSendOtpBtnClicked: {
    type: Boolean,
    default: false,
  },
  isBankSelected: {
    type: Boolean,
    default: false,
  },
  payload: {
    type: Object,
    default: () => {},
  },
});

const isSendOTPBtnDisabled = ref(false);
const isLoading = ref(false);
const phone = ref("");

const { sendOTP, timer } = useOtp({
  isSendOTPBtnDisabled,
  isLoading,
  enableAfterInSeconds: 120,
  phone,
  payload: props.payload,
});

const isTimerShown = computed(() => {
  return Boolean(unref(timer) !== "00:00");
});

const computedBtnLabel = computed(() => {
  if (unref(isSendOTPBtnDisabled)) {
    return "Code Sent";
  }

  if (unref(props.isSendOtpBtnClicked)) {
    return "Resend Code";
  }

  return "Send Code";
});
</script>
